<template>
  <div class="status-card status-processing">
    <div class="status-header">
      <div class="status-icon-wrapper processing">
        <img
          alt="processing"
          width="48px"
          :src="iconDocs"
        >
      </div>
      <h3 class="status-title">
        Hoàn tất ký hợp đồng
      </h3>
    </div>

    <div class="status-content">
      <p class="status-description">
        <template v-if="contractCode">
          Hợp đồng mã <span class="contract-code-highlight">{{ contractCode }}</span> chưa được ký xong.
          Vui lòng kiểm tra mail hoặc SMS và truy cập vào link hợp đồng để hoàn tất việc ký kết. Nếu bạn không tìm thấy hợp đồng ở mail và SMS, vui lòng liên hệ support để được hỗ trợ.
        </template>
        <template v-else>
          Chỉ còn một bước nữa để hoàn tất! Vui lòng kiểm tra email hoặc SMS để hoàn tất việc ký hợp đồng.
        </template>
      </p>

      <div class="action-section">
        <div class="action-item">
          <div class="action-icon">
            <img
              alt="email"
              width="24px"
              :src="iconEmailSquare"
            >
          </div>
          <div class="action-content">
            <p class="action-title">
              Kiểm tra email
            </p>
            <p class="action-description">
              Kiểm tra email (bao gồm cả thư mục spam) để tìm hợp đồng cần ký
            </p>
          </div>
        </div>

        <div class="action-item">
          <div class="action-icon">
            <img
              alt="sms"
              width="24px"
              :src="iconChatMessage"
            >
          </div>
          <div class="action-content">
            <p class="action-title">
              Kiểm tra SMS
            </p>
            <p class="action-description">
              Kiểm tra tin nhắn SMS trên điện thoại của bạn
            </p>
          </div>
        </div>
      </div>

      <div class="action-buttons">
        <a
          href="https://mail.google.com/mail/u/0/#inbox"
          target="_blank"
          rel="noopener noreferrer"
          class="btn-link-submit"
        >
          <div class="d-flex align-items-center">
            <div class="btn-icon-wrapper">
              <img
                alt="gmail"
                width="20px"
                :src="iconEmailSquare"
              >
            </div>
            <span class="ml-1">Mở Gmail</span>
          </div>
        </a>
      </div>

      <user-hint class="justify-content-center mt-4" />
    </div>
  </div>
</template>

<script>
import UserHint from '@/components/UserHint.vue'
import iconDocs from '@/assets/images/common/ic-docs.svg'
import iconEmailSquare from '@/assets/images/icons/ic-email-square.svg'
import iconChatMessage from '@/assets/images/icons/ic-chat-message.svg'
import { createNamespacedHelpers } from 'vuex'

const { mapGetters } = createNamespacedHelpers('auth')

export default {
  name: 'ProcessingStatus',

  components: {
    UserHint,
  },

  data() {
    return {
      iconDocs,
      iconEmailSquare,
      iconChatMessage,
    }
  },

  computed: {
    ...mapGetters(['user']),

    contractCode() {
      return this.user?.data?.vContract?.contractCode || ''
    },
  },
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variables/_variables.scss";

.status-card {
  background: #ffffff;
  border-radius: 16px;
  padding: 32px;

  @media(max-width: 767px) {
    padding: 24px;
    border-radius: 12px;
  }
}

.status-header {
  text-align: center;
  margin-bottom: 28px;
}

.status-icon-wrapper {
  width: 80px;
  height: 80px;
  margin: 0 auto 16px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;

  img {
    display: block;
    margin: 0 auto;
  }

  &.processing {
    background: linear-gradient(135deg, rgba(34, 197, 94, 0.1) 0%, rgba(59, 130, 246, 0.1) 100%);

    img {
      display: block;
      margin: 0 auto;
      object-fit: contain;
    }
  }
}

.status-title {
  font-size: 24px;
  font-weight: 600;
  color: #1f2937;
  margin: 0;
  line-height: 1.4;

  @media(max-width: 767px) {
    font-size: 20px;
  }
}

.status-content {
  text-align: left;
}

.status-description {
  font-size: 16px;
  line-height: 1.6;
  color: #4b5563;
  margin-bottom: 24px;
  text-align: center;

  @media(max-width: 767px) {
    font-size: 14px;
    margin-bottom: 20px;
  }

  .contract-code-highlight {
    display: inline-block;
    background: linear-gradient(135deg, rgba(34, 197, 94, 0.1) 0%, rgba(59, 130, 246, 0.1) 100%);
    border: 1px solid rgba(34, 197, 94, 0.3);
    border-radius: 8px;
    padding: 4px 10px;
    font-weight: 700;
    font-size: 16px;
    color: #1f2937;
    letter-spacing: 0.3px;
    vertical-align: middle;

    @media(max-width: 767px) {
      font-size: 14px;
    }
  }

  &.support-note {
    font-size: 14px;
    color: #6b7280;
    margin-bottom: 24px;
    margin-top: -8px;

    @media(max-width: 767px) {
      font-size: 13px;
      margin-bottom: 20px;
      margin-top: -4px;
    }
  }
}

.action-section {
  background: #f9fafb;
  border-radius: 12px;
  padding: 20px;
  margin-bottom: 24px;
}

.action-item {
  display: flex;
  align-items: flex-start;
  gap: 16px;

  & + & {
    margin-top: 20px;
    padding-top: 20px;
    border-top: 1px solid #e5e7eb;
  }
}

.action-icon {
  flex-shrink: 0;
  width: 40px;
  height: 40px;
  border-radius: 8px;
  background: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.action-content {
  flex: 1;
}

.action-title {
  font-size: 16px;
  font-weight: 600;
  color: #1f2937;
  margin: 0 0 4px 0;
  line-height: 1.4;

  @media(max-width: 767px) {
    font-size: 14px;
  }
}

.action-description {
  font-size: 14px;
  line-height: 1.5;
  color: #6b7280;
  margin: 0;

  @media(max-width: 767px) {
    font-size: 13px;
  }
}

.action-buttons {
  display: flex;
  flex-direction: column;
  gap: 12px;

  @media(min-width: 768px) {
    flex-direction: row;
    justify-content: center;
    flex-wrap: wrap;
  }

  .btn-link-submit {
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: 180px;
    gap: 12px;
    text-decoration: none;
    color: #fff;
    background: linear-gradient(128.33deg, var(--button-color-start) -29.89%, var(--button-color-end) 98.77%);
    border: none;
    border-radius: var(--btn-border-radius-base);
    padding: 11px 20px;
    font-size: 14px;
    font-weight: 600;
    transition: all 0.3s ease;

    &:hover {
      color: #fff !important;
      box-shadow: 0 8px 25px -8px var(--btn-submit-box-shadow) !important;
      text-decoration: none;
    }

    img {
      display: inline-block;
    }
  }
}

.btn-icon-wrapper {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: #ffffff;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  vertical-align: middle;

  img {
    width: 18px;
    height: auto;
    display: block;
  }

  @media(max-width: 767px) {
    width: 28px;
    height: 28px;

    img {
      width: 16px;
    }
  }
}
</style>
